var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m12.855 3.914 9.726 16.069a1 1 0 0 1-.855 1.517H2.274a1 1 0 0 1-.855-1.517l9.725-16.07a1 1 0 0 1 1.711 0M12 8.5a.5.5 0 0 1 .5.5v5.5a.5.5 0 1 1-1 0V9a.5.5 0 0 1 .5-.5m0 9a.5.5 0 0 1 .5.5v1a.5.5 0 1 1-1 0v-1a.5.5 0 0 1 .5-.5",
    clipRule: "evenodd"
  })));
});
const SvgAlertFilled = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAlertFilled);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMi44NTUzIDMuOTEzODRMMjIuNTgxMiAxOS45ODI2QzIyLjk4NDYgMjAuNjQ5MSAyMi41MDQ3IDIxLjUwMDQgMjEuNzI1NyAyMS41MDA0SDIuMjc0MDJDMS40OTUgMjEuNTAwNCAxLjAxNTE0IDIwLjY0OTEgMS40MTg1MiAxOS45ODI2TDExLjE0NDMgMy45MTM4NEMxMS41MzM1IDMuMjcwOTEgMTIuNDY2MiAzLjI3MDkxIDEyLjg1NTMgMy45MTM4NFpNMTEuOTk5OCA4LjUwMDRDMTIuMjc2IDguNTAwNCAxMi40OTk4IDguNzI0MjYgMTIuNDk5OCA5LjAwMDRWMTQuNTAwNEMxMi40OTk4IDE0Ljc3NjUgMTIuMjc2IDE1LjAwMDQgMTEuOTk5OCAxNS4wMDA0QzExLjcyMzcgMTUuMDAwNCAxMS40OTk4IDE0Ljc3NjUgMTEuNDk5OCAxNC41MDA0VjkuMDAwNEMxMS40OTk4IDguNzI0MjYgMTEuNzIzNyA4LjUwMDQgMTEuOTk5OCA4LjUwMDRaTTExLjk5OTggMTcuNTAwNEMxMi4yNzYgMTcuNTAwNCAxMi40OTk4IDE3LjcyNDMgMTIuNDk5OCAxOC4wMDA0VjE5LjAwMDRDMTIuNDk5OCAxOS4yNzY1IDEyLjI3NiAxOS41MDA0IDExLjk5OTggMTkuNTAwNEMxMS43MjM3IDE5LjUwMDQgMTEuNDk5OCAxOS4yNzY1IDExLjQ5OTggMTkuMDAwNFYxOC4wMDA0QzExLjQ5OTggMTcuNzI0MyAxMS43MjM3IDE3LjUwMDQgMTEuOTk5OCAxNy41MDA0WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";